<mat-card *ngIf="!isLoggedIn"> <mat-card-content>log in please</mat-card-content></mat-card>

<ng-container *ngIf="isLoggedIn">
  <div class="grid-top">
    <mat-card class="card">
      <mat-card-header>
        <mat-card-title>commands</mat-card-title>
      </mat-card-header>
      <mat-card-actions>
        <mat-progress-spinner *ngIf="!checkedOwnCharacters" mode="indeterminate" class="spinner"></mat-progress-spinner>
        <button *ngIf="!character && checkedOwnCharacters" mat-raised-button color="accent" (click)="createCharacter()">
          create simulator character
        </button>
        <ng-container *ngIf="character">
          <button mat-raised-button color="accent" (click)="createInstances()">create instances</button>
          <button mat-raised-button color="accent" (click)="connect()">connect</button>
          <button mat-raised-button color="accent" (click)="joinRoom()">join room</button>
          <button mat-raised-button color="accent" (click)="sendMessage()">send message</button>
        </ng-container>
      </mat-card-actions>
    </mat-card>

    <mat-card class="card">
      <mat-card-header>
        <mat-card-title>settings</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <mat-form-field appearance="outline">
          <mat-label>instances</mat-label>
          <input matInput type="number" [(ngModel)]="instancesCount" />
          <mat-hint>max 100 instances</mat-hint>
        </mat-form-field>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="grid-mid">
    <mat-card *ngFor="let instance of instances" class="card">
      <mat-card-header> </mat-card-header>
      <mat-card-content>
        <p>connected: {{ !!instance.ws }}</p>
        <p>messages received: {{ instance.messagesReceived }}</p>
      </mat-card-content>
    </mat-card>
  </div>
</ng-container>
